export enum RoundingPolicy {
    RoundUp = 0,
    RoundDown = 1,
    RoundMid = 2
}

export class Currency {

    static defaultCode = "USD";

    static round(amount: number, currencyCode: string = Currency.defaultCode, roundingPolicy: RoundingPolicy = RoundingPolicy.RoundUp) {
        const currencyDecimals = Currency.getDecimalDigits(currencyCode);

        // Round the amount using the defined rounding policy
        const currencyFactor = Math.pow(10, currencyDecimals);
        switch (roundingPolicy) {
            case RoundingPolicy.RoundUp:
                return Math.ceil(amount * currencyFactor) / currencyFactor;
            case RoundingPolicy.RoundDown:
                return Math.floor(amount * currencyFactor) / currencyFactor;
            case RoundingPolicy.RoundMid:
            default: // RoundingPolicy.RoundMid
                return Math.round(amount * currencyFactor) / currencyFactor;
        }
    }

    static exchange(amount: number, currencyCode: string, newCurrencyCode: string = Currency.defaultCode): number {
        return amount * Currency.getExchangeRate(currencyCode, newCurrencyCode);
    }

	static getExchangeRate(sourceCurrencyCode: string, destinationCurrencyCode: string): number {
        if (sourceCurrencyCode === destinationCurrencyCode) return 1;

        // The exchange rate of the source and destination currency to USD should be looked up
        // and the rate for source divided by the rate for destination, but for now we just throw an exception.
        throw new Error("Currency exchange is not currently supported.");
    }

	static getDecimalDigits(currencyCode: string): number {
        const parts = new Intl.NumberFormat("en-US", { style: "currency", currency: currencyCode })["formatToParts"](0);
        return parts.find(part => part.type === "fraction")?.value?.length ?? 0;
    }
}